import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced = true;
const state = {
    bottomPadding: 0,
};

export const layout = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
